"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Hyperlink.css");
var Hyperlink = (function (_super) {
    __extends(Hyperlink, _super);
    function Hyperlink(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            ref: null,
        };
        _this._onClick = _this._onClick.bind(_this);
        _this._onRef = _this._onRef.bind(_this);
        _this._setTitleAttr = _this._setTitleAttr.bind(_this);
        return _this;
    }
    Hyperlink.prototype._onClick = function (event) {
        if (this.props.url === "")
            event.preventDefault();
        if (this.props.isEnabled)
            this.props.onClick ? this.props.onClick(event) : null;
    };
    Hyperlink.prototype._onRef = function (ref) {
        this.setState({ ref: ref });
    };
    Hyperlink.prototype._setTitleAttr = function () {
        var ref = this.state.ref;
        var _a = this.props, tooltip = _a.tooltip, text = _a.text, wrapMode = _a.wrapMode;
        if (!ref) {
            return;
        }
        ref.removeAttribute("title");
        if (tooltip) {
            ref.setAttribute("title", tooltip);
        }
        else if (ref.offsetWidth < ref.scrollWidth && wrapMode === "Ellipsis") {
            ref.setAttribute("title", text);
        }
    };
    Hyperlink.prototype.componentDidMount = function () {
        window.addEventListener('resize', this._setTitleAttr);
    };
    Hyperlink.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this._setTitleAttr);
    };
    Hyperlink.prototype.render = function () {
        var ref = this.state.ref;
        var _a = this.props, text = _a.text, tooltip = _a.tooltip, wrapMode = _a.wrapMode;
        var cssClasses = ["p-link"];
        var attrs = {
            "aria-hidden": this.props.ariaHidden,
            "aria-label": this.props.ariaLabel,
            "data-tag": this.props.tag,
            "tabIndex": this.props.tabIndex,
            "role": this.props.role,
            "onClick": this._onClick,
        };
        function customizeEnums(en) {
            var cases = {
                'Xsmall': 'xs',
                'Small': 'sm',
                'Default': 'd',
                'Medium': 'md',
                'Large': 'lg',
                'Xlarge': 'xl',
                'Xlarge2': '2x',
                'Xlarge3': '3x',
                'Xlarge4': '4x',
                'Xlarge5': '5x',
                'Baseline': 'bl',
                'Sub': 'sb',
                'Super': 'sp',
                'Top': 't',
                'TextTop': 'tt',
                'Middle': 'm',
                'Bottom': 'b',
                'TextBottom': 'tb',
                'Initial': 'ini',
                'Inherit': 'inh',
                'Ellipsis': 'el',
                'ForceWrap': 'fw',
                'Block': 'bl',
                'Inline': 'in',
                'InlineBlock': 'ib'
            };
            return cases[en]
                ? cases[en].toLowerCase()
                : en.toLowerCase();
        }
        function constructClass(prop, prefix) {
            if (prop && prop !== 'None') {
                var customProp = customizeEnums(prop);
                cssClasses.push(prefix + "-" + customProp);
            }
        }
        var hasLinkStyle = (this.props.buttonType != "None") ? false : this.props.hasLinkStyle;
        if (tooltip) {
            attrs["title"] = tooltip;
        }
        else if (ref && ref.offsetWidth < ref.scrollWidth && wrapMode === "Ellipsis") {
            attrs["title"] = text;
        }
        if (this.props.ariaExpanded !== undefined)
            attrs['aria-expanded'] = this.props.ariaExpanded;
        if (this.props.isEnabled && this.props.target && this.props.target !== "None")
            attrs["target"] = "_" + this.props.target.toLowerCase();
        var navUrl = "";
        switch (this.props.type) {
            case "Mail":
                navUrl = "mailto:" + this.props.url;
                break;
            case "Phone":
                navUrl = "tel:" + this.props.url;
                break;
            case "Action":
                navUrl = "javascript:void(0);";
                break;
            default:
                navUrl = this.props.url;
                break;
        }
        if (!React.Children.toArray(this.props.children).length)
            constructClass(this.props.size, 'p-f-sz');
        if (hasLinkStyle && this.props.isEnabled) {
            cssClasses.push("p-link-def");
            if (!React.Children.toArray(this.props.children).length)
                cssClasses.push("p-t-full-hv-primary50 p-f-w-6");
        }
        if (!React.Children.toArray(this.props.children).length && this.props.wrapMode != "None")
            constructClass(this.props.wrapMode, "p-t-wr");
        if (this.props.hundredPercentHeight)
            cssClasses.push("p-height-100");
        if (this.props.displayType != "Inline")
            constructClass(this.props.displayType, 'p-bl');
        if (this.props.buttonType != "None") {
            cssClasses.push("p-link-btn", "basic", this.props.buttonType.toLowerCase());
        }
        if (this.props.vAlign != "None")
            constructClass(this.props.vAlign, 'p-t-va');
        if (this.props.hasTextShadow)
            cssClasses.push("p-t-s");
        if (this.props.isEnabled) {
            return (React.createElement("a", __assign({ ref: this._onRef, className: cssClasses.join(' '), href: navUrl }, attrs), (React.Children.toArray(this.props.children).length) ? this.props.children : this.props.text));
        }
        else {
            return (React.createElement("span", { className: cssClasses.join(' ') }, (React.Children.toArray(this.props.children).length) ? this.props.children : this.props.text));
        }
    };
    return Hyperlink;
}(React.Component));
Hyperlink.defaultProps = {
    isEnabled: true,
    type: "Url",
    text: "",
    tooltip: "",
    url: "#",
    target: "None",
    size: "Default",
    hasLinkStyle: true,
    hasTextShadow: false,
    wrapMode: "None",
    hundredPercentHeight: false,
    displayType: "Inline",
    buttonType: "None",
    vAlign: "None",
    tabIndex: null,
    tag: null,
    onClick: function () { },
    ariaHidden: null,
    ariaLabel: null,
    role: null,
    ariaExpanded: undefined
};
exports.Hyperlink = Hyperlink;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['common-controls'])
        csod.engine.controls['common-controls'] = {};
    csod.engine.controls['common-controls']['Hyperlink'] = Hyperlink;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["Hyperlink"] = undefined;


//////////////////
// WEBPACK FOOTER
// ../player-common-controls/controls/Hyperlink/index.js
// module id = 27
// module chunks = 0